import React from "react";
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

function PaymentSuccessful() {
  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "50vh" }}
    >
      <div style={{ textAlign: "center" }}>
        <div className="d-flex align-items-center justify-content-center mb-4">
          <div
            className="me-3"
            style={{
              color: "#28a745",
              fontSize: "2.2rem",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              fill="currentColor"
              className="bi bi-check-circle-fill"
              viewBox="0 0 16 16"
            >
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>
          </div>
          <h2 className="mb-0 fs-1">Plaćanje uspješno!</h2>
        </div>
        <p className="fs-4 mb-4">
          Detalji vaše narudžbe su poslani na vašu e-mail adresu, te će uskoro
          biti vidljivi na Dashboardu.
        </p>
        <p className="fs-5">
          Povratak na{" "}
          <Link to="/dashboard">
            <Button variant="primary" size="lg">
              Dashboard
            </Button>
          </Link>
        </p>
      </div>
    </Container>
  );
}

export default PaymentSuccessful;
